// i18n area 'networks' — locale pt-BR (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da networks.pt-PT.ts e sovrascrive SOLO le chiavi
// che il brasiliano scrive davvero in un altro modo: lessico (usuário,
// arquivo, tela, senha, registro, seção, configurações, salvar, console) e
// morfologia verbale (il progressivo 'está a fazer' → 'está fazendo').
// DA RIVEDERE DA MADRELINGUA: restano fuori le scelte a bassa confidenza
// (alojar/hospedar, eliminar/excluir, arranque/inicialização) e la posizione
// dei clitici, che una regola meccanica non sa spostare.
// Sidecar anti-stantie: ../meta/networks.pt-BR.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './networks'

export const ptBR: DeepPartial<typeof enUS> = {
  networks: {
    common: {
      save: 'Salvar',
      saveError: 'Impossível salvar'
    },
    overlay: {
      subnetHint: 'O CIDR da overlay — o IPAM deriva dele automaticamente a entrada de registro'
    },
    services: {
      checkTcp: 'Conexão TCP',
      vpn: {
        tunnelSubnetHint: 'A rede onde vivem os clientes — registada no registro IPAM, nasce e morre com este serviço'
      }
    },
    fabric: {
      overviewHint: 'A fabric num relance: cada rede lógica com MTU e subnet (as VLANs vivem só nos mapeamentos por porta/por LAGG — a mesma rede pode viajar com tags diferentes em portas diferentes). A fabric é o registro de uma infraestrutura EXTERNA — o TVirt observa e declara, nunca faz provisioning, e só toca nas NICs registadas sob o seu controlo.',
      absorptionHint: 'Cada subnet declarada aqui DERIVA a sua entrada no registro IPAM na mesma escrita — vive e morre com a rede.',
      switchesHint: 'O registro manual: uma porta está não usada, mapeada (tráfego untagged e por VLAN tag nas redes lógicas) ou é membro de um LAGG — um membro não traz mapeamentos próprios.',
      cidrHint: 'Obrigatório — o IPAM deriva dele automaticamente a entrada de registro'
    }
  }
}
